import { BreadcrumbJsonLd } from 'next-seo';
import PropTypes from 'prop-types';

import {
  toAbsoluteLink,
  toStoreCouponsLink,
  toStoreOffersLink,
} from 'lib/links';
import placeholder from 'lib/placeholder';
import { toFormattedJsonLdString } from 'lib/string';

import StoreJsonLd from './StoreJsonLd';

import APP from 'constants/app';
import LINKS from 'constants/links';

const StoreSchema = ({
  isOfferPage,
  metaDescription,
  storeDomain,
  storeImage,
  storeName,
  storeRating,
  storeRatingCount,
  storeSlug,
}) => (
  <>
    <BreadcrumbJsonLd
      itemListElements={[
        {
          position: 1,
          name: placeholder('breadcrumbs.app'),
          item: APP.URL,
        },
        {
          position: 2,
          name: isOfferPage
            ? placeholder('breadcrumbs.stores')
            : placeholder('breadcrumbs.coupons'),
          item: toAbsoluteLink(LINKS.STORES),
        },
        {
          position: 3,
          name: storeName,
          item: isOfferPage
            ? toAbsoluteLink(toStoreOffersLink(storeSlug))
            : toAbsoluteLink(toStoreCouponsLink(storeSlug)),
        },
      ]}
    />
    <StoreJsonLd
      metaDescription={toFormattedJsonLdString(metaDescription)}
      metaTitle={toFormattedJsonLdString(storeName)}
      storeDomain={storeDomain}
      storeImage={storeImage}
      storeRating={storeRating}
      storeRatingCount={storeRatingCount}
    />
  </>
);

StoreSchema.propTypes = {
  isOfferPage: PropTypes.bool.isRequired,
  metaDescription: PropTypes.string.isRequired,
  storeDomain: PropTypes.string.isRequired,
  storeImage: PropTypes.string.isRequired,
  storeName: PropTypes.string.isRequired,
  storeRating: PropTypes.number.isRequired,
  storeRatingCount: PropTypes.number.isRequired,
  storeSlug: PropTypes.string.isRequired,
};

export default StoreSchema;
